// @flow
import { Sparkle, Check } from 'lucide-react';

import { Text, View } from 'reshaped';

import { Icon } from '@gandi/reshaped';
import { useTranslator } from '@gandi/translate';

export const FeaturesBanner = (): React.MixedElement => {
  const { __ } = useTranslator();

  const features = [
    __('Modern Standard'),
    __('Easy to use'),
    __('Easy to manage'),
  ];

  return (
    <View
      as="div"
      gap={4}
      direction={{ m: 'row' }}
      borderRadius="small"
      paddingBlock={4}
      paddingInline={6}
      wrap={{ s: true }}
      attributes={{
        style: {
          background:
            'linear-gradient(90deg, var(--rs-color-background-neutral-faded) 8.62%, var(--color-background-product-certificate-faded) 89.09%)',
          marginBottom: 'var(--rs-unit-x10)',
        },
      }}
    >
      <View gap={1} direction="row" align="baseline">
        <Icon svg={Sparkle} size={3} color="product-certificate" />
        <Text
          as="p"
          weight="bold"
          attributes={{
            style: {
              color: 'var(--color-foreground-product-certificate)',
            },
          }}
        >
          {__('Our Subscription')}
        </Text>
      </View>

      <View as="ul" gap={{ s: 1, m: 4 }} direction={{ m: 'row' }}>
        {features.map(feature => (
          <View gap={1} direction="row" align="center" as="li" key={feature}>
            <Icon svg={Check} size={4} color="product-certificate" />
            {feature}
          </View>
        ))}
      </View>
    </View>
  );
};
